import { Box, Typography } from '@mui/material';
import React from 'react';

interface LayoutErrorBoundaryProps {
    children: React.ReactNode;
}

interface LayoutErrorBoundaryState {
    hasError: boolean;
    error?: Error;
}

class LayoutErrorBoundary extends React.Component<LayoutErrorBoundaryProps, LayoutErrorBoundaryState> {
    constructor(props: LayoutErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): LayoutErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Layout Error Boundary caught an error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '200px',
                        p: 3,
                        backgroundColor: 'background.paper',
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="h6" sx={{ mb: 2, color: 'error.main' }}>
                        Layout Error
                    </Typography>
                    <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                        Something went wrong with the page layout. Please try refreshing the page.
                    </Typography>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default LayoutErrorBoundary;